import { render, staticRenderFns } from "./PurchasesTreeTable.vue?vue&type=template&id=bab561f8&scoped=true"
import script from "./PurchasesTreeTable.vue?vue&type=script&lang=js"
export * from "./PurchasesTreeTable.vue?vue&type=script&lang=js"
import style0 from "./PurchasesTreeTable.vue?vue&type=style&index=0&id=bab561f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab561f8",
  null
  
)

export default component.exports